import React, { FC } from 'react';
import { EntityWithDecisionsToShow } from '../../entity/entity.types';
import {
  ModalScrollableContent,
  ModalScrollableBody,
} from '../../components/modal';
import { EntityDecisionList } from './EntityDecisionList';
import { EntityDecisionListFetcher } from './EntityDecisionListFetcher';
import { EntityDecisionListModalHeaderGoBack } from './EntityDecisionListModalHeaderGoBack';
import { EntityDecisionLoader } from './EntityDecisionLoader';

type Props = {
  entityWithDecisionsToShowInfos: EntityWithDecisionsToShow;
  wording: string;
  closeModal: () => void;
  handleGoBack: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  source: string;
};

export const EntityDecisionListModalWithGoBack: FC<Props> = ({
  entityWithDecisionsToShowInfos,
  wording,
  closeModal,
  handleGoBack,
  source,
}) => (
  <EntityDecisionListFetcher params={entityWithDecisionsToShowInfos.params}>
    {(decisions) => (
      <>
        <EntityDecisionListModalHeaderGoBack
          title={entityWithDecisionsToShowInfos.name}
          subtitle={`${wording} dans ${decisions.length} décision${
            decisions.length > 1 ? 's' : ''
          }`}
          onClose={closeModal}
          onGoBack={handleGoBack}
        />
        <ModalScrollableContent>
          <ModalScrollableBody>
            {decisions.length ? (
              <EntityDecisionList decisions={decisions} source={source} />
            ) : (
              <EntityDecisionLoader />
            )}
          </ModalScrollableBody>
        </ModalScrollableContent>
      </>
    )}
  </EntityDecisionListFetcher>
);
